import React, { useState } from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { LoginContainer, LoginOrRegisterContainer } from "../Login/Login.styles";
import { StyledEngineProvider } from "@mui/material";
import { MeshGradient, NavigationBar, Stepper } from "../../components";
import { ResetPasswordInterface } from "../../models/Login";
import { BasicInfo, EmailSent, Password, Success } from "../../components/ResetPassword";

interface ResetPasswordProps extends WithRouterProps {
}

const ResetPassword: React.FC<ResetPasswordProps> = ({
    router,
}) => {
  const token = router.query.token || "";
  const email = router.query.email || "";

  const decodedToken = token && !Array.isArray(token) ? decodeURIComponent(token).replace(/ /g, "+") : "";

  const resetPasswordQueryObj: ResetPasswordInterface = {
    token: decodedToken,
    user: {
      email: email && !Array.isArray(email) ? email : "",
      password: ""
    }
  }
  
  const [step, setStep] = useState(token ? 2 : 0);

  const nextStep = () => {
      setStep(step + 1);
  };

  const prevStep = () => {
      setStep(step - 1);
  };

  return (
    <StyledEngineProvider injectFirst>
      <NavigationBar showMenu={false} />
      <LoginContainer>
        <LoginOrRegisterContainer>
            {step === 0 && <BasicInfo onNextButtonClick={nextStep} />}
            {step === 1 && <EmailSent />}
            {step === 2 && <Password resetPasswordInitialData={resetPasswordQueryObj} goToNextStep={nextStep} />}
            {step === 3 && <Success />}
        </LoginOrRegisterContainer>
        <MeshGradient sx={{ position: 'fixed' }} colour={"teal-green"} position="bottom" size="low" />
      </LoginContainer>
    </StyledEngineProvider>
  );
}

export default withRouter(ResetPassword);